// extracted by mini-css-extract-plugin
export default {"wrap":"OfferFormHeaderOptions_wrap__JPHB1","checkboxWrap":"OfferFormHeaderOptions_checkboxWrap__dFDOm"};